export enum TarriffSections {
	OVERVIEW,
	RULES_SELECT,
	RULES_CREATE,
	RULES_LIST,
	NOTIFICATIONS,
	LOG
}